const MFA_CHOICE = {
  EMAIL: "Email",
  SMS: "SMS",
};

export default MFA_CHOICE;
